import createMutator from '../../utils/createMutator';

export const setElements = createMutator('set', 'elements');
export const setPage = createMutator('set', 'page');
export const setLastPage = createMutator('set', 'lastPage');